export default "__VITE_ASSET__CoeWL2Gg__"